import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  getCourseApplicantsSuccess,
  getCourseApplicantsFailed,
} from '../actions';
import { CoursesActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchCourseApplicants({ data }) {
  const { id } = data;

  const url = `${API_BASE_URL}/courses/${id}/applicants`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(getCourseApplicantsSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Apllicants`);
    yield put(getCourseApplicantsFailed(response.message));
  }
}

export function* getCourseApplicants() {
  yield takeEvery(
    CoursesActionTypes.GET_COURSES_APLLICANTS,
    fetchCourseApplicants
  );
}
